import { Section, Title } from '@/components/ui/layout';
import { ChurchPicker } from './church-picker';
import { useChurchCopy } from './church-copy';

export function Discovery(): JSX.Element {
  const copy = useChurchCopy();
  return (
    <Section className="giving-discovery" aria-labelledby="giving-discovery-title" flow>
      <Title level={2} id="giving-discovery-title">
        {copy.choose}
      </Title>
      <ChurchPicker />
    </Section>
  );
}
